import { m } from "framer-motion";
import { Col, Container, Row } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import emailjs from "@emailjs/browser";
import { useNavigate } from "react-router-dom";

const ContactUs = () => {
  const navigate = useNavigate();

  const otherOffices = [
    { name: "RPMU Kottayam", phone: "9037824037" },
    { name: "RPMU Thrissur", phone: "9037824050" },
    { name: "RPMU Kannur", phone: "9037824046" },
    { name: "PIU KAU", phone: "9037824030" },
    { name: "PIU Industries", phone: "9037824027" },
    { name: "PIU KSUM", phone: "9037824057" },
  ];

  // Validation schema
  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    message: Yup.string().required("Message is required"),
  });

  // Form submit handler
  const handleSubmit = (values, { resetForm, setSubmitting }) => {
    const serviceID = "service_6ik7l7s";
    const templateID = "template_31b6api";
    const publicKey = "rFMRyrhHTh3tdsNI9";

    emailjs
      .send(serviceID, templateID, values, publicKey)
      .then(() => {
        alert("Message sent successfully ✅");
        resetForm();
      })
      .catch(() => {
        alert("Failed to send ❌");
      })
      .finally(() => setSubmitting(false));
  };

  return (
    <m.div className="mt-[200px] ">
      <Container>
        <Col xl={8} lg={10} className="text-center w-fit">
          <h3 className="font-serif text-[30px] mb-[2px] font-medium text-[#146084] ">
            Contact us
          </h3>
          <m.div
            className="border-b border-1 w-[40%] border-[#146084]"
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          />
        </Col>

        {/* Contact Info */}
        <Row className="mt-[50px] p-[20px]">
          <Col lg={6} md={6} sm={12} className="pr-[20px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d126271.90900933793!2d76.92428090000001!3d8.4996555!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x3b05bb0023b23bc5%3A0xd6276d8b4bff740f!2sGround%20Floor%2C%20T.C.%2029%2F2599-28%2C%20Cotton%20Hill%20Rd%2C%20Laposhe%2C%20Vazhuthacaud%2C%20Thiruvananthapuram%2C%20Kerala%20695014!3m2!1d8.5014687!2d76.9615081!5e0!3m2!1sen!2sin!4v1768814696973!5m2!1sen!2sin"
              width="600"
              height="400"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </Col>
          <Col lg={6} md={6} sm={12}>
            <m.p className="text-[20px] mb-[20px] text-black font-bold">
              State Project Management Unit (SPMU)
            </m.p>
            <m.p className="text-[17px] mb-[20px] text-black font-semibold">
              Kerala Climate Resilient Agri-Value Chain Modernization (KERA)
              Project
            </m.p>
            <m.p className="text-[16px] text-black mb-[20px] ">
              T.C. 29/2599-28, Ground Floor, Laposhe,
              <br />
              Vazhuthacaud Cotton Hill Road,
              <br />
              Thiruvananthapuram, Kerala - 695014
            </m.p>
            <div className="flex gap-[10px] items-center ">
              <i className="fa fa-phone " aria-hidden="true"></i>
              <m.a href="tel:+914712320447" className="text-[16px] text-black ">
                : +914712320447
              </m.a>
            </div>
            <div className="flex gap-[10px] text items-center mt-[10px] ">
              <i className="fa fa-envelope" aria-hidden="true"></i>:{" "}
              <p className="text-[black]">
                info[at]kera[dot]kerala[dot]gov[dot]in
              </p>
            </div>
          </Col>
        </Row>

        {/* Other Offices */}
        <div className="mt-[50px]">
          <Col xl={8} lg={10} className="text-center w-fit">
            <h3 className="font-serif text-[25px] mb-[2px] mt-[40px] font-medium text-[black] ">
              Other Offices
            </h3>
            <div className="border-b border-1 w-[40%] border-[black]" />
          </Col>

          <Row className="mt-[30px] justify-center p-[20px]">
            <Col lg={8} md={10} sm={12}>
              <div className="bg-white rounded-lg shadow-md p-[30px]">
                {otherOffices.map((office, idx) => (
                  <div
                    key={idx}
                    className="flex justify-between items-center py-[15px] border-b border-gray-200 last:border-b-0"
                  >
                    <p className="text-[16px] font-medium text-black">
                      {office.name}
                    </p>
                    <a
                      href={`tel:${office.phone}`}
                      className="text-[16px] text-[#146084] hover:text-[#0f4d68] transition flex items-center gap-[8px]"
                    >
                      <i
                        className="fa fa-phone fa-flip-horizontal"
                        aria-hidden="true"
                      ></i>
                      {office.phone}
                    </a>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </div>

        {/* Contact Form */}
        <div className="mt-[30px] mb-[30px]">
          <Col xl={8} lg={10} className="text-center w-fit">
            <h3 className="font-serif text-[25px] mb-[2px] mt-[40px] font-medium text-[black] ">
              Send us a message
            </h3>
            <div className="border-b border-1 w-[40%] border-[black]" />
          </Col>
          <Row className="mt-[50px] justify-center p-[20px]">
            <Col lg={8} md={8} sm={12}>
              <Formik
                initialValues={{
                  name: "",
                  email: "",
                  message: "",
                }}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ isSubmitting }) => (
                  <Form className="flex flex-col gap-4">
                    <div>
                      <Field
                        name="name"
                        placeholder="Your Name"
                        className="w-full p-3 border rounded"
                      />
                      <ErrorMessage
                        name="name"
                        component="div"
                        className="text-red-500 text-sm"
                      />
                    </div>
                    <div>
                      <Field
                        type="email"
                        name="email"
                        placeholder="Your Email"
                        className="w-full p-3 border rounded"
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="text-red-500 text-sm"
                      />
                    </div>
                    <div>
                      <Field
                        as="textarea"
                        name="message"
                        placeholder="Your Message"
                        className="w-full p-3 border rounded h-32"
                      />
                      <ErrorMessage
                        name="message"
                        component="div"
                        className="text-red-500 text-sm"
                      />
                    </div>
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="bg-[#146084] text-white px-6 py-3 rounded hover:bg-[#0f4d68] transition"
                    >
                      {isSubmitting ? "Sending..." : "Send Message"}
                    </button>
                  </Form>
                )}
              </Formik>
            </Col>
          </Row>
        </div>
      </Container>
    </m.div>
  );
};

export default ContactUs;
